// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (width >= 1200px) and (width <= 1649px) {
  .hidden-lg {
    display: none !important;
  }
}

.visible-xl-block, .visible-xl-inline, .visible-xl-inline-block, .visible-xl {
  display: none !important;
}

@media (width >= 1650px) {
  .container {
    width: 1620px;
  }

  .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12 {
    float: left;
  }

  .col-xl-12 {
    width: 100%;
  }

  .col-xl-11 {
    width: 91.6667%;
  }

  .col-xl-10 {
    width: 83.3333%;
  }

  .col-xl-9 {
    width: 75%;
  }

  .col-xl-8 {
    width: 66.6667%;
  }

  .col-xl-7 {
    width: 58.3333%;
  }

  .col-xl-6 {
    width: 50%;
  }

  .col-xl-5 {
    width: 41.6667%;
  }

  .col-xl-4 {
    width: 33.3333%;
  }

  .col-xl-3 {
    width: 25%;
  }

  .col-xl-2 {
    width: 16.6667%;
  }

  .col-xl-1 {
    width: 8.33333%;
  }

  .col-xl-pull-12 {
    right: 100%;
  }

  .col-xl-pull-11 {
    right: 91.6667%;
  }

  .col-xl-pull-10 {
    right: 83.3333%;
  }

  .col-xl-pull-9 {
    right: 75%;
  }

  .col-xl-pull-8 {
    right: 66.6667%;
  }

  .col-xl-pull-7 {
    right: 58.3333%;
  }

  .col-xl-pull-6 {
    right: 50%;
  }

  .col-xl-pull-5 {
    right: 41.6667%;
  }

  .col-xl-pull-4 {
    right: 33.3333%;
  }

  .col-xl-pull-3 {
    right: 25%;
  }

  .col-xl-pull-2 {
    right: 16.6667%;
  }

  .col-xl-pull-1 {
    right: 8.33333%;
  }

  .col-xl-pull-0 {
    right: auto;
  }

  .col-xl-push-12 {
    left: 100%;
  }

  .col-xl-push-11 {
    left: 91.6667%;
  }

  .col-xl-push-10 {
    left: 83.3333%;
  }

  .col-xl-push-9 {
    left: 75%;
  }

  .col-xl-push-8 {
    left: 66.6667%;
  }

  .col-xl-push-7 {
    left: 58.3333%;
  }

  .col-xl-push-6 {
    left: 50%;
  }

  .col-xl-push-5 {
    left: 41.6667%;
  }

  .col-xl-push-4 {
    left: 33.3333%;
  }

  .col-xl-push-3 {
    left: 25%;
  }

  .col-xl-push-2 {
    left: 16.6667%;
  }

  .col-xl-push-1 {
    left: 8.33333%;
  }

  .col-xl-push-0 {
    left: auto;
  }

  .col-xl-offset-12 {
    margin-left: 100%;
  }

  .col-xl-offset-11 {
    margin-left: 91.6667%;
  }

  .col-xl-offset-10 {
    margin-left: 83.3333%;
  }

  .col-xl-offset-9 {
    margin-left: 75%;
  }

  .col-xl-offset-8 {
    margin-left: 66.6667%;
  }

  .col-xl-offset-7 {
    margin-left: 58.3333%;
  }

  .col-xl-offset-6 {
    margin-left: 50%;
  }

  .col-xl-offset-5 {
    margin-left: 41.6667%;
  }

  .col-xl-offset-4 {
    margin-left: 33.3333%;
  }

  .col-xl-offset-3 {
    margin-left: 25%;
  }

  .col-xl-offset-2 {
    margin-left: 16.6667%;
  }

  .col-xl-offset-1 {
    margin-left: 8.33333%;
  }

  .col-xl-offset-0 {
    margin-left: 0;
  }

  .visible-xl {
    display: block !important;
  }

  table.visible-xl {
    display: table;
  }

  tr.visible-xl {
    display: table-row !important;
  }

  th.visible-xl, td.visible-xl {
    display: table-cell !important;
  }

  .visible-xl-block {
    display: block !important;
  }

  .visible-xl-inline {
    display: inline !important;
  }

  .visible-xl-inline-block {
    display: inline-block !important;
  }

  .hidden-xl {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/styles/BootstrapXL.css","webpack://./services/frontend/app/containers/App/styles/BootstrapXL.css"],"names":[],"mappings":"AAQA;ECPE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/*\n*   CSS file with Bootstrap grid classes for screens bigger than 1600px. Just add this file after the Bootstrap CSS file and you will be able to juse col-xl, col-xl-push, hidden-xl, etc.\n*\n*   Author: Marc van Nieuwenhuijzen\n*   Company: WebVakman\n*   Site: WebVakman.nl\n*\n*/\n\n@media (min-width: 1200px) and (max-width: 1649px) {\n  .hidden-lg {\n    display: none !important;\n  }\n}\n\n.visible-xl-block,\n.visible-xl-inline,\n.visible-xl-inline-block,\n.visible-xl {\n  display: none !important;\n}\n\n@media (min-width: 1650px) {\n  .container {\n    width: 1620px;\n  }\n\n  .col-xl-1,\n  .col-xl-2,\n  .col-xl-3,\n  .col-xl-4,\n  .col-xl-5,\n  .col-xl-6,\n  .col-xl-7,\n  .col-xl-8,\n  .col-xl-9,\n  .col-xl-10,\n  .col-xl-11,\n  .col-xl-12 {\n    float: left;\n  }\n\n  .col-xl-12 {\n    width: 100%;\n  }\n\n  .col-xl-11 {\n    width: 91.66666667%;\n  }\n\n  .col-xl-10 {\n    width: 83.33333333%;\n  }\n\n  .col-xl-9 {\n    width: 75%;\n  }\n\n  .col-xl-8 {\n    width: 66.66666667%;\n  }\n\n  .col-xl-7 {\n    width: 58.33333333%;\n  }\n\n  .col-xl-6 {\n    width: 50%;\n  }\n\n  .col-xl-5 {\n    width: 41.66666667%;\n  }\n\n  .col-xl-4 {\n    width: 33.33333333%;\n  }\n\n  .col-xl-3 {\n    width: 25%;\n  }\n\n  .col-xl-2 {\n    width: 16.66666667%;\n  }\n\n  .col-xl-1 {\n    width: 8.33333333%;\n  }\n\n  .col-xl-pull-12 {\n    right: 100%;\n  }\n\n  .col-xl-pull-11 {\n    right: 91.66666667%;\n  }\n\n  .col-xl-pull-10 {\n    right: 83.33333333%;\n  }\n\n  .col-xl-pull-9 {\n    right: 75%;\n  }\n\n  .col-xl-pull-8 {\n    right: 66.66666667%;\n  }\n\n  .col-xl-pull-7 {\n    right: 58.33333333%;\n  }\n\n  .col-xl-pull-6 {\n    right: 50%;\n  }\n\n  .col-xl-pull-5 {\n    right: 41.66666667%;\n  }\n\n  .col-xl-pull-4 {\n    right: 33.33333333%;\n  }\n\n  .col-xl-pull-3 {\n    right: 25%;\n  }\n\n  .col-xl-pull-2 {\n    right: 16.66666667%;\n  }\n\n  .col-xl-pull-1 {\n    right: 8.33333333%;\n  }\n\n  .col-xl-pull-0 {\n    right: auto;\n  }\n\n  .col-xl-push-12 {\n    left: 100%;\n  }\n\n  .col-xl-push-11 {\n    left: 91.66666667%;\n  }\n\n  .col-xl-push-10 {\n    left: 83.33333333%;\n  }\n\n  .col-xl-push-9 {\n    left: 75%;\n  }\n\n  .col-xl-push-8 {\n    left: 66.66666667%;\n  }\n\n  .col-xl-push-7 {\n    left: 58.33333333%;\n  }\n\n  .col-xl-push-6 {\n    left: 50%;\n  }\n\n  .col-xl-push-5 {\n    left: 41.66666667%;\n  }\n\n  .col-xl-push-4 {\n    left: 33.33333333%;\n  }\n\n  .col-xl-push-3 {\n    left: 25%;\n  }\n\n  .col-xl-push-2 {\n    left: 16.66666667%;\n  }\n\n  .col-xl-push-1 {\n    left: 8.33333333%;\n  }\n\n  .col-xl-push-0 {\n    left: auto;\n  }\n\n  .col-xl-offset-12 {\n    margin-left: 100%;\n  }\n\n  .col-xl-offset-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .col-xl-offset-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .col-xl-offset-9 {\n    margin-left: 75%;\n  }\n\n  .col-xl-offset-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .col-xl-offset-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .col-xl-offset-6 {\n    margin-left: 50%;\n  }\n\n  .col-xl-offset-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .col-xl-offset-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .col-xl-offset-3 {\n    margin-left: 25%;\n  }\n\n  .col-xl-offset-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .col-xl-offset-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .col-xl-offset-0 {\n    margin-left: 0;\n  }\n\n  .visible-xl {\n    display: block !important;\n  }\n\n  table.visible-xl {\n    display: table;\n  }\n\n  tr.visible-xl {\n    display: table-row !important;\n  }\n\n  th.visible-xl,\n  td.visible-xl {\n    display: table-cell !important;\n  }\n\n  .visible-xl-block {\n    display: block !important;\n  }\n\n  .visible-xl-inline {\n    display: inline !important;\n  }\n\n  .visible-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .hidden-xl {\n    display: none !important;\n  }\n}\n","@media (width >= 1200px) and (width <= 1649px) {\n  .hidden-lg {\n    display: none !important;\n  }\n}\n\n.visible-xl-block, .visible-xl-inline, .visible-xl-inline-block, .visible-xl {\n  display: none !important;\n}\n\n@media (width >= 1650px) {\n  .container {\n    width: 1620px;\n  }\n\n  .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12 {\n    float: left;\n  }\n\n  .col-xl-12 {\n    width: 100%;\n  }\n\n  .col-xl-11 {\n    width: 91.6667%;\n  }\n\n  .col-xl-10 {\n    width: 83.3333%;\n  }\n\n  .col-xl-9 {\n    width: 75%;\n  }\n\n  .col-xl-8 {\n    width: 66.6667%;\n  }\n\n  .col-xl-7 {\n    width: 58.3333%;\n  }\n\n  .col-xl-6 {\n    width: 50%;\n  }\n\n  .col-xl-5 {\n    width: 41.6667%;\n  }\n\n  .col-xl-4 {\n    width: 33.3333%;\n  }\n\n  .col-xl-3 {\n    width: 25%;\n  }\n\n  .col-xl-2 {\n    width: 16.6667%;\n  }\n\n  .col-xl-1 {\n    width: 8.33333%;\n  }\n\n  .col-xl-pull-12 {\n    right: 100%;\n  }\n\n  .col-xl-pull-11 {\n    right: 91.6667%;\n  }\n\n  .col-xl-pull-10 {\n    right: 83.3333%;\n  }\n\n  .col-xl-pull-9 {\n    right: 75%;\n  }\n\n  .col-xl-pull-8 {\n    right: 66.6667%;\n  }\n\n  .col-xl-pull-7 {\n    right: 58.3333%;\n  }\n\n  .col-xl-pull-6 {\n    right: 50%;\n  }\n\n  .col-xl-pull-5 {\n    right: 41.6667%;\n  }\n\n  .col-xl-pull-4 {\n    right: 33.3333%;\n  }\n\n  .col-xl-pull-3 {\n    right: 25%;\n  }\n\n  .col-xl-pull-2 {\n    right: 16.6667%;\n  }\n\n  .col-xl-pull-1 {\n    right: 8.33333%;\n  }\n\n  .col-xl-pull-0 {\n    right: auto;\n  }\n\n  .col-xl-push-12 {\n    left: 100%;\n  }\n\n  .col-xl-push-11 {\n    left: 91.6667%;\n  }\n\n  .col-xl-push-10 {\n    left: 83.3333%;\n  }\n\n  .col-xl-push-9 {\n    left: 75%;\n  }\n\n  .col-xl-push-8 {\n    left: 66.6667%;\n  }\n\n  .col-xl-push-7 {\n    left: 58.3333%;\n  }\n\n  .col-xl-push-6 {\n    left: 50%;\n  }\n\n  .col-xl-push-5 {\n    left: 41.6667%;\n  }\n\n  .col-xl-push-4 {\n    left: 33.3333%;\n  }\n\n  .col-xl-push-3 {\n    left: 25%;\n  }\n\n  .col-xl-push-2 {\n    left: 16.6667%;\n  }\n\n  .col-xl-push-1 {\n    left: 8.33333%;\n  }\n\n  .col-xl-push-0 {\n    left: auto;\n  }\n\n  .col-xl-offset-12 {\n    margin-left: 100%;\n  }\n\n  .col-xl-offset-11 {\n    margin-left: 91.6667%;\n  }\n\n  .col-xl-offset-10 {\n    margin-left: 83.3333%;\n  }\n\n  .col-xl-offset-9 {\n    margin-left: 75%;\n  }\n\n  .col-xl-offset-8 {\n    margin-left: 66.6667%;\n  }\n\n  .col-xl-offset-7 {\n    margin-left: 58.3333%;\n  }\n\n  .col-xl-offset-6 {\n    margin-left: 50%;\n  }\n\n  .col-xl-offset-5 {\n    margin-left: 41.6667%;\n  }\n\n  .col-xl-offset-4 {\n    margin-left: 33.3333%;\n  }\n\n  .col-xl-offset-3 {\n    margin-left: 25%;\n  }\n\n  .col-xl-offset-2 {\n    margin-left: 16.6667%;\n  }\n\n  .col-xl-offset-1 {\n    margin-left: 8.33333%;\n  }\n\n  .col-xl-offset-0 {\n    margin-left: 0;\n  }\n\n  .visible-xl {\n    display: block !important;\n  }\n\n  table.visible-xl {\n    display: table;\n  }\n\n  tr.visible-xl {\n    display: table-row !important;\n  }\n\n  th.visible-xl, td.visible-xl {\n    display: table-cell !important;\n  }\n\n  .visible-xl-block {\n    display: block !important;\n  }\n\n  .visible-xl-inline {\n    display: inline !important;\n  }\n\n  .visible-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .hidden-xl {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
